import "./booking-context-intro.css";
import "./booking-person-selector.css";
import type { BookingPersonPresentation } from "./lib/bookingPersonPresentation";
import { KATRIN_PORTRAIT_PATH, RAYK_PORTRAIT_PATH } from "./lib/portrait";
import { PersonPortrait } from "./PersonPortrait";

type BookingContextIntroProps = {
  mode: "online" | "berlin";
  bookingPerson: BookingPersonPresentation;
};

export function BookingContextIntro({ mode, bookingPerson }: BookingContextIntroProps) {
  const isRayk = bookingPerson.slug === "rayk";

  if (mode === "online") {
    return (
      <section className="booking-context booking-context--online">
        <div>
          <p>
            Online ·{" "}
            1:1 mit {bookingPerson.name}
          </p>
          <h1>{isRayk ? "Was braucht gerade Bewegung?" : "Was braucht gerade Unterstützung?"}</h1>
          <span>
            {isRayk
              ? "Du musst die Antwort noch nicht kennen. Wähle nur den Rahmen, der deinem Anliegen am nächsten kommt. Dauer, Preis und die nächsten freien Online-Termine siehst du direkt."
              : "Wähle die passende Dauer für deine persönliche 1:1-Arbeit. Preis und die nächsten freien Online-Termine siehst du direkt."}
          </span>
        </div>
        <aside
          className="booking-context__presence"
          aria-label={`Persönlicher Termin mit ${bookingPerson.name}`}
        >
          <PersonPortrait
            name={bookingPerson.name}
            initial={bookingPerson.initial}
            photoSrc={isRayk ? RAYK_PORTRAIT_PATH : KATRIN_PORTRAIT_PATH}
          />
          <div className="booking-context__facts">
            <span>Google Meet</span>
            <span>{isRayk ? "Laufend buchbar" : "1:1 · auf Rechnung"}</span>
          </div>
        </aside>
      </section>
    );
  }

  return (
    <section className="booking-context booking-context--berlin">
      <div>
        <p>Berlin · 1:1 mit {bookingPerson.name}</p>
        <h1>Was braucht gemeinsamen Raum?</h1>
        <span>
          Du musst dein Anliegen nicht schon fertig erklären können. Wähle den Rahmen, der am
          ehesten passt. Dauer, Preis und freie Präsenztermine in Berlin-Weißensee ab 10. November
          siehst du direkt.
        </span>
      </div>
      <aside
        className="booking-context__presence"
        aria-label={`Persönlicher Termin mit ${bookingPerson.name}`}
      >
        <PersonPortrait
          name={bookingPerson.name}
          initial={bookingPerson.initial}
          photoSrc={isRayk ? RAYK_PORTRAIT_PATH : KATRIN_PORTRAIT_PATH}
        />
        <div className="booking-context__facts">
          <span>Berlin-Weißensee</span>
          <span>ab 10. November</span>
        </div>
      </aside>
    </section>
  );
}
